import React, { useContext, useEffect, useRef, useState } from "react"
import {
  FilterH,
  RowButton,
} from "../../../StyledComponents"
import { Input } from "reactstrap"
import shoe from "../../../assets/images/dummyImages/shoe.png"
import shorts from "../../../assets/images/dummyImages/shorts.png"
import shirt from "../../../assets/images/dummyImages/shirt.png"
import cap from "../../../assets/images/dummyImages/cap.png"
import { FaSearch } from "react-icons/fa"
import Rating from "react-rating"
import { ThemeColors } from "@src/utility/context/ThemeColors"
import PeekOtherCategories from "../../Manage/PeekOtherCategories"
import ProductsYouMayLike from "../../Manage/ProductsYouMayLike"
import axios from "axios"
import { API_URLS } from "../../../utility/api/endpoints/endpoints"
import { useLocation } from "react-router-dom"
import { useDispatch } from "react-redux"
import { setFilteredProducts } from "../../../utility/api/services/Products/ProductSlice"
import { Star } from "react-feather"
import { MdTune } from "react-icons/md";



const ProductFilter = ({ categoryId, categoryName }) => {
  const themeColors = useContext(ThemeColors)

  const [filterData, setFilterData] = useState([])
  const dispatch = useDispatch()
  const [showFilters, setShowFilters] = useState(false)
  const toggleFilters = () => setShowFilters(prev => !prev)



  const Peeks = [
    {
      img: shoe,
      name: "Sneakers Shoes",
    },
    {
      img: shorts,
      name: "Pants and Shorts",
    },
    {
      img: shirt,
      name: "Full sleeve shirts",
    },
    {
      img: cap,
      name: "Caps",
    },
  ]


  const data = [
    {
      title: "services",
      items: [
        "Free Delivery",
        "Cash on Delivery",
        "Installments",
        "Authentic Brands",
      ],
    },
    {
      title: "sorting",
      items: ["New Arrival", "On Sale", "Best Selling"],
    },
    {
      title: "brands",
      items: [
        "Adidas",
        "Nike",
        "Fila",
        "Puma",
        "Converse",
        "Asics",
        "Timberland",
        "Reebok",
        "Sportturtle",
        "For the game",
      ],
    },
    {
      title: "Color Choice",
      items: [
        "#41B8E4",
        "#EC7426",
        "#FBBD34",
        "#ffffff",
        "#45CC7B",
        "#E45959",
        "#A186BD",
        "#FF6900",
        "#FCB900",
        "#7BDCB5",
        "#00D084",
        "#8ED1FC",
        "#0693E3",
        "#ABB8C3",
        "#EB144C",
        "#F78DA7",
        "#9900EF",
      ],
    },
    {
      title: "size",
      items: ["Extra Small", "Small", "Medium", "Large", "Extra Large"],
    },
    {
      title: "range",
      items: [], // No items needed here since range is handled separately
      minValue: 1000,
      maxValue: 50000,
    }, // Assuming no items needed for range
    {
      title: "warranty",
      items: [
        "Seller warranty",
        "Brand warranty",
        "Local-seller warranty",
        "Local-brand warranty",
        "No warranty",
      ],
    },
    {
      title: "Rating",
      items: ["5", "4", "3", "2", "1"],
    },
  ]

  const [minValue, setMinValue] = useState()
  const [maxValue, setMaxValue] = useState()

  const [selectedOptions, setSelectedOptions] = useState({
    services: [],
    sorting: [],
    brands: [],
    searchQuery: "",
    color: "",
    size: [],
    minPrice: 0,
    maxPrice: 0,
    warranty: [],
    rating: [],
  })

  const [showMoreBrands, setShowMoreBrands] = useState(false)
  const [showMoreColors, setShowMoreColors] = useState(false)




  const handleCheckboxChange = (category, value) => {
    setSelectedOptions((prevSelected) => {
      const currentCategory = prevSelected[category]
      const isChecked = currentCategory.includes(value)

      const updatedCategory = isChecked
        ? currentCategory.filter((item) => item !== value)
        : [...currentCategory, value]

      return {
        ...prevSelected,
        [category]: updatedCategory,
      }
    })
  }

  // Handle color selection
  const handleColorSelection = (color) => {
    setSelectedOptions((prevSelected) => ({
      ...prevSelected,
      color: color,
    }))
  }

  // Handle search input for brands
  const handleSearch = (e) => {
    setSelectedOptions({ ...selectedOptions, searchQuery: e.target.value })
  }

  // Filter brands based on search query 
  const brandSection = filterData?.brands
  const filteredBrands = brandSection?.filter((brand) =>
    brand.toLowerCase().includes(selectedOptions.searchQuery.toLowerCase())
  )

  // Limit the number of brands displayed unless "view more" is clicked
  const visibleBrands = showMoreBrands
    ? filteredBrands
    : filteredBrands?.slice(0, 5)

  // Limit the number of colors displayed unless "view more" is clicked
  const colorSection = data?.find((section) => section.title === "Color Choice")
  const visibleColors = showMoreColors
    ? colorSection.items
    : colorSection.items?.slice(0, 7)

  // Format selected options into an object, including the search query
  const formatSelectedOptions = () => {
    const formattedOptions = {
      services: "",
      sorting: "",
      brands: "",
      brandSearch: "",
      color: "",
      size: "",
      minPrice: selectedOptions.minPrice,
      maxPrice: selectedOptions.maxPrice,
      warranty: "",
      rating: "",
    }

    Object.keys(selectedOptions).forEach((category) => {
      if (category === "searchQuery") {
        if (selectedOptions[category]) {
          formattedOptions["brandSearch"] = selectedOptions[category]
        }
      } else if (category === "color") {
        if (selectedOptions[category]) {
          formattedOptions[category] = selectedOptions[category]
        }
      } else if (selectedOptions[category]?.length > 0) {
        formattedOptions[category] = selectedOptions[category]?.map((item) => item?.toLowerCase()?.replace(/\s+/g, "_"))?.join(", ")
      }
    })
    return formattedOptions
  }

  const selectedObject = formatSelectedOptions()



  const handleMinChange = (e) => {
    const value = Math.min(Number(e.target.value), maxValue)
    setMinValue(value)
    setSelectedOptions((prev) => ({ ...prev, minPrice: value })) // Update minPrice in the selectedOptions
  }

  const handleMaxChange = (e) => {
    const value = Math.max(Number(e.target.value), minValue)
    setMaxValue(value)
    setSelectedOptions((prev) => ({ ...prev, maxPrice: value })) // Update maxPrice in the selectedOptions
  }

  // useEffect(() => {
  //   // Ensure the display shows the correct range values
  //   document.querySelector('.rangeValues').innerText = `$${minValue} - $${maxValue}`;
  // }, [minValue, maxValue]);

  const clearFilters = () => {
    setSelectedOptions({
      services: [],
      sorting: [],
      brands: [],
      searchQuery: "",
      color: "",
      size: [],
      minPrice: minValue,
      maxPrice: maxValue,
      warranty: [],
      rating: [],
    })
    setMinValue(minValue)
    setMaxValue(maxValue)
  }

  const fetchFilterData = async () => {

    try {
      const id = categoryId

      const { data } = await axios.get(
        `${API_URLS.GET_FILTER_DATA}/${id}/filters`
      )
      if (data.statusCode === 200) {
        setFilterData(data.data)
        setSelectedOptions((prev) => ({ ...prev, minPrice: data.data.priceRange.min, maxPrice: data.data.priceRange.max }))
      } else {
        setFilterData([])
      }
    } catch (error) {
      console.log("error fetching the product filter: ", error);
    }
  }

  // const { data: filteredProducts, isError, isLoading } = useQuery({
  //   queryKey: ['filteredProducts'], queryFn: async () => (
  //     await axios.get(
  //       `${API_URLS.FETCH_FILTERED_PRODUCTS}/67189dbf26fe6ad0276ecc91?miniPrice=1000&brand=addidas&size=S&color=white&service=free delivery&sortBy=New Arrivals`
  //     ))
  // })

  // console.log("query client: ", filteredProducts);


  const fetchFilterProducts = async () => {

    try {
      const id = categoryId

      // const { data } = await axios.get(
      //   `${API_URLS.FETCH_FILTERED_PRODUCTS}/${id}?miniPrice=${selectedOptions.minPrice}&brand=${selectedOptions.brands[0]}&size=${selectedOptions.size[0]}&color=${selectedOptions.color[0]}&service=${selectedOptions.services[0]}&sortBy=${selectedOptions.sorting[0]}`
      // )

      const { data } = await axios.get(
        `${API_URLS.FETCH_FILTERED_PRODUCTS}/67189dbf26fe6ad0276ecc91?size=L,S`
      );

      if (data.statusCode === 200) {
        dispatch(setFilteredProducts(data.data))
      }
    } catch (error) {
      console.log("error fetching the product filter: ", error);
    }
  }

  useEffect(() => {
    fetchFilterData()
  }, [categoryId])

  useEffect(() => {
    if (filterData?.priceRange) {
      setMinValue(filterData.priceRange.min)
      setMaxValue(filterData.priceRange.max)
    }
  }, [filterData?.priceRange])

  const isOptionsSelected = () => {
    const {
      services,
      sorting,
      brands,
      color,
      size,
      minPrice,
      maxPrice,
      warranty,
      rating,
    } = selectedOptions;

    return (
      services.length > 0 ||
      sorting.length > 0 ||
      brands.length > 0 ||
      color !== "" ||
      size.length > 0 ||
      minPrice > 0 ||
      maxPrice > 0 ||
      warranty.length > 0 ||
      rating.length > 0
    );
  };

  const handleResize = () => {
    if (window.screen.width > 767) setShowFilters(true)
  }

  useEffect(() => {
    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, [])


  return (
    <>
      <div>
        <div className="d-flex d-md-none align-items-center justify-content-end mb-2" onClick={toggleFilters}>
          <div>{showFilters ? "Hide" : "Apply Filters"}</div>
          <div><MdTune size={24} /></div>
        </div>
        <div className={`d-${showFilters ? "block" : "none"}`} style={{ marginBottom: '20px', border: '1px solid #EC7426', padding: '20px' }}>
          <FilterH>Filter</FilterH>
          <div className="fs-5 fs-md-4 fw-medium">Category</div>
          <div style={{ color: '#EC7426', fontWeight: 500 }} >{categoryName || 'No Category Selected'}</div>

          {/* {filterData && filterData.length === 0 && (
            <div className="alert alert-warning">
              No filter data available.
            </div>
          )} */}

          {/* Services Filter */}
          <div>
            <div className="fs-5 fs-md-4 fw-medium">Services</div>
            {filterData?.services?.length > 0 ? (
              filterData.services.map((item, index) => (
                <div style={{ marginBottom: "2px" }} key={index}>
                  <Input
                    type='checkbox'
                    checked={selectedOptions.services.includes(item)}
                    onChange={() => handleCheckboxChange("services", item)}
                  />
                  <label style={{ marginLeft: '4px' }}>{item}</label>
                </div>
              ))
            ) : (
              <div>No Filters Available</div>
            )}
          </div>

          {/* Sorting Filter */}
          <div>
            <div className="fs-5 fs-md-4 fw-medium">Sorting</div>
            {filterData?.sortingOptions?.length > 0 ? (
              filterData.sortingOptions.map((item, index) => (
                <div style={{ marginBottom: "2px" }} key={index}>
                  <Input
                    type='checkbox'
                    checked={selectedOptions.sorting.includes(item)}
                    onChange={() => handleCheckboxChange("sorting", item)}
                  />
                  <label style={{ marginLeft: '4px' }}>{item}</label>
                </div>
              ))
            ) : (
              <div>No Filters for sorting</div>
            )}
          </div>

          {/* Brands Filter */}
          <div>
            <div className="fs-5 fs-md-4 fw-medium">Brands</div>
            <div style={{ position: "relative", marginBottom: "8px" }}>
              <Input
                style={{ borderRadius: "20px", paddingRight: "40px" }}
                type='text'
                placeholder='Search brand'
                value={selectedOptions.searchQuery}
                onChange={handleSearch}
              />
              <FaSearch
                style={{
                  position: "absolute",
                  right: "10px",
                  top: "50%",
                  transform: "translateY(-50%)",
                  color: "#ccc",
                  pointerEvents: "none",
                }}
              />
            </div>
            {filteredBrands?.length > 0 ? (
              filteredBrands?.map((item, index) => (
                <div style={{ marginBottom: "2px" }} key={index}>
                  <Input
                    type='checkbox'
                    checked={selectedOptions.brands.includes(item)}
                    onChange={() => handleCheckboxChange("brands", item)}
                  />
                  <label style={{ marginLeft: '4px' }}>{item}</label>
                </div>
              ))
            ) : (
              <div>No Filters for brands</div>
            )}
            {/* {filterData?.brands?.length > 0 ? (
              filterData.brands.map((item, index) => (
                <div style={{ marginBottom: "2px" }} key={index}>
                  <Input
                    type='checkbox'
                    checked={selectedOptions.brands.includes(item)}
                    onChange={() => handleCheckboxChange("brands", item)}
                  />
                  <label style={{ marginLeft: '4px' }}>{item}</label>
                </div>
              ))
            ) : (
              <div>No Filters for brands</div>
            )} */}
          </div>

          {/* Color Choice Filter */}
          <div>
            <div className="fs-5 fs-md-4 fw-medium">Color Choice</div>
            {filterData?.colors?.length > 0 ? (
              <div style={{ display: "flex", flexWrap: "wrap", gap: ".5rem" }}>
                {filterData.colors.map((item, index) => (
                  <div
                    key={index}
                    style={{
                      width: "24px",
                      height: "17px",
                      backgroundColor: item?.toLowerCase(),
                      borderRadius: "3px",
                      border:
                        selectedOptions.color === item?.toLowerCase()
                          ? "2px solid black"
                          : "none",
                      cursor: "pointer",

                    }}
                    onClick={() => handleColorSelection(item)}
                  />
                ))}
              </div>
            ) : (
              <div>No Filters for colors</div>
            )}
          </div>

          {/* Size Filter */}
          <div>
            <div className="fs-5 fs-md-4 fw-medium">Size</div>
            {filterData?.sizes?.length > 0 ? (
              filterData.sizes.map((item, index) => (
                <div style={{ marginBottom: "2px" }} key={index}>
                  <Input
                    type='checkbox'
                    checked={selectedOptions.size.includes(item)}
                    onChange={() => handleCheckboxChange("size", item)}
                  />
                  <label style={{ marginLeft: '4px' }}>{item}</label>
                </div>
              ))
            ) : (
              <div>No Filters for sizes</div>
            )}
          </div>
          {/* Price Range Filter */}
          <div>
            <div className="fs-5 fs-md-4 fw-medium">Range</div>
            {filterData?.priceRange ? (
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  width: "100%",
                }}
              >
                <div
                  className='range-slider'
                  style={{ width: "100%", padding: "0 0 20px 0" }}
                >
                  <Input
                    type='range'
                    value={minValue}
                    min={filterData.priceRange.min}
                    max={filterData.priceRange.max}
                    step='2'
                    onChange={handleMinChange}
                  />
                  <Input
                    type='range'
                    value={maxValue}
                    min={filterData.priceRange.min}
                    max={filterData.priceRange.max}
                    step='2'
                    onChange={handleMaxChange}
                  />
                </div>
                <div
                  style={{
                    marginTop: "10px",
                    display: "flex",
                    flexDirection: "row",
                    flexWrap: "wrap",
                    justifyContent: "space-between",
                    width: "100%",
                  }}
                >
                  <div
                    style={{
                      backgroundColor: "#F2F2F2",
                      borderRadius: "5px",
                      padding: "0.5rem",
                      fontSize: "10px",
                      fontWeight: "600",
                      width: "45%",
                      justifyContent: "space-between",
                      display: "flex",
                    }}
                  >
                    <span>Min:</span>
                    <span style={{ color: "#EC7426" }}>{minValue}</span>
                  </div>
                  <div
                    style={{
                      backgroundColor: "#F2F2F2",
                      borderRadius: "5px",
                      padding: "0.5rem",
                      fontSize: "10px",
                      fontWeight: "600",
                      width: "45%",
                      justifyContent: "space-between",
                      display: "flex",
                    }}
                  >
                    <span>Max:</span>
                    <span style={{ color: "#EC7426" }}>{maxValue}</span>
                  </div>
                </div>
              </div>
            ) : (
              <div>No Filters for Price Range</div>
            )}
          </div>

          {/* Warranty Filter */}
          <div>
            <div className="fs-5 fs-md-4 fw-medium">Warranty</div>
            {filterData?.warranties?.length > 0 ? (
              filterData.warranties.map((item, index) => (
                <div style={{ marginBottom: "2px" }} key={index}>
                  <Input
                    type='checkbox'
                    checked={selectedOptions.warranty.includes(item)}
                    onChange={() => handleCheckboxChange("warranty", item)}
                  />
                  <label style={{ marginLeft: '4px' }}>{item}</label>
                </div>
              ))
            ) : (
              <div>No Filters Available for warranty</div>
            )}
          </div>

          {/* Ratings Filter */}
          <div>
            <div className="fs-5 fs-md-4 fw-medium">Ratings</div>
            {filterData?.ratings?.length > 0 ? (
              filterData.ratings.map((item, index) => (
                <div key={index} style={{ marginBottom: "2px" }}>
                  <Input
                    type='checkbox'
                    checked={selectedOptions.rating.includes(item)}
                    onChange={() => handleCheckboxChange("rating", item)}
                  />
                  <Rating
                    readonly={true}
                    initialRating={item}
                    emptySymbol={
                      <Star size={15} fill='#babfc7' stroke='#babfc7' />
                    }
                    fullSymbol={
                      <Star
                        size={15}
                        fill={themeColors.colors.warning.main}
                        stroke={themeColors.colors.warning.main}
                      />
                    }
                  />
                </div>
              ))
            ) : (
              <div>No Filters Available for ratings</div>
            )}
          </div>

          <div style={{ display: "flex", justifyContent: "center" }}>

            {isOptionsSelected() && (
              <>
                <RowButton
                  type='button'
                  block
                  onClick={clearFilters}
                  color='light-primary'
                  style={{
                    width: "124px",
                    maxWidth: "100%",
                    backgroundColor: "#EC7426",
                    height: "30px",
                    maxHeight: "100%",
                    margin: "0.5rem",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  Clear Filters
                </RowButton>

                <RowButton
                  type='button'
                  block
                  onClick={fetchFilterProducts}
                  color='light-primary'
                  style={{
                    width: "124px",
                    maxWidth: "100%",
                    backgroundColor: "#EC7426",
                    height: "30px",
                    maxHeight: "100%",
                    margin: "0.5rem",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  Apply Filters
                </RowButton>
              </>
            )}
          </div>
        </div>

        <PeekOtherCategories Peeks={Peeks} categoryId={categoryId} />
        <ProductsYouMayLike down={true} categoryId={categoryId} />
      </div>
    </>
  )
}

export default ProductFilter
